<div class="xux-dnd-list-item" [class.isDrag]="isDragModeObs | async">
  <div class="list-item-header">
    <div class="list-item-header-panel">
      <xux-drag-icon
        *ngIf="isDragModeObs | async"
        class="crp"
      ></xux-drag-icon>
      <span class="list-item-title" *ngIf="itemData?.title">{{
        itemData?.title ?? ''
      }}</span>
      <div class="list-item-auto-refresh-control">
        <xux-input-switch
          *ngIf="autoRefreshSwitchFields?.title"
          [class.disabled]="(field?.disabledObs | async)"
          [field]="autoRefreshSwitchFields"
        ></xux-input-switch>
      </div>
    </div>

    <div class="list-item-header-actions">
      <xux-close-icon
        *ngIf="isDragModeObs | async"
        class="xux-icon-close"
        (click)="removeClick()"
      ></xux-close-icon>
    </div>
  </div>

  <div class="xux-dnd-item-wrapper">
    <div class="xux-dnd-item" [class.isDrag]="isDragModeObs | async">
      <xux-schema-form
        *ngIf="!!form"
        [dynamicWidgetsMap]="dndConfig?.widgetsMap"
        [defaultWidgetFamily]="defaultWidgetFamily"
        [form]="form"
        [groups]="groups"
        [beforeChange]="beforeFormGroupChange"
        [groupIndexControl]="groupIndexControl"
        (onFormAction)="onFormAction($event)"
      ></xux-schema-form>
    </div>

    <xux-loader-small
      [cssScale]="0.75"
      [isLoaderVisible]="getShowLoaderObs() | async"
    ></xux-loader-small>
    <div class="overlay" *ngIf="isDragModeObs | async"></div>
  </div>
</div>
